import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    colorBorderActionSecondary,
    colorBgActionPrimaryActive,
    colorTextActionPrimary,
    borderWidth2,
    borderRadiusFull,
    space6,
    space16,
  } = theme();

  return StyleSheet.create({
    button: {
      alignContent: "center",
      borderColor: colorBorderActionSecondary,
      borderRadius: borderRadiusFull,
      borderWidth: borderWidth2,
      flex: 1,
      height: space16,
      justifyContent: "center",
      marginHorizontal: 12,
      paddingLeft: space6,
      paddingRight: space6,
    },
    buttonActive: {
      backgroundColor: colorBgActionPrimaryActive,
    },
    text: {
      textAlign: "center",
    },
    textActive: {
      color: colorTextActionPrimary,
    },
  });
};

export { style };
